import { createFileRoute, redirect } from "@tanstack/react-router";

// Spain's co-official languages redirect to the castellano legal page, matching
// the edge rules in apps/marketing/public/_redirects. The legally operative
// content of these pages is Spanish statutory text, and Xeito publishes its
// legal pages in castellano only — see legal.languageNote.
const LEGAL_PAGE_EXCLUDED_LOCALES = ["ca", "va", "gl", "eu"];

export const Route = createFileRoute("/$locale/legal-notice")({
  beforeLoad: ({ params }) => {
    if (LEGAL_PAGE_EXCLUDED_LOCALES.includes(params.locale)) {
      throw redirect({ to: "/$locale/legal-notice", params: { locale: "es" } });
    }
  },
});
